import { useEventDesignTheming } from '@apps/guest/routes/GuestSite/GuestSite.utils';
import { useEventWebsiteGuestQuery, EventDesignPurpose, DesignLayoutType } from '@graphql/generated';
import { JoyKitThemeProvider } from '@withjoy/joykit';
import React, { useState } from 'react';
import { FontPackProvider } from '../../layouts/FontPackProvider/FontPackProvider';
import EventMenu from '../../layouts/LayoutAloha/components/EventMenu/EventMenu';
import { LayoutProvider } from '../../layouts/LayoutProvider';
import { UnlockDialogProvider } from '../UnlockDialog/UnlockDialogProvider';
import { SmartAppBannerProvider } from '@shared/components';
import { ColorPaletteProvider } from '../../layouts/ColorPaletteProvider/ColorPaletteProvider';
import { EventTopBar } from '../EventTopBar';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';

interface StandAloneAlohaMenuProps
  extends Readonly<{
    readonly eventHandle: string;
  }> {}

export const StandAloneAlohaMenu: React.FC<StandAloneAlohaMenuProps> = ({ eventHandle }) => {
  const isMobile = useIsMobileScreen();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { data, loading, error } = useEventWebsiteGuestQuery({
    variables: {
      eventHandle,
      eventDesignPurpose: EventDesignPurpose.live,
      isAdminDashboard: false,
    },
    batchMode: 'fast',
    ssr: true,
    fetchPolicy: 'cache-first',
  });
  const { theme } = useEventDesignTheming({ eventDesign: data?.eventByName?.eventDesign });

  if (loading || error || !data?.eventByName || isMobile) {
    return null;
  }

  const handleMenuOpen = () => setIsDrawerOpen(true);
  const handleMenuClose = () => setIsDrawerOpen(false);

  return (
    <JoyKitThemeProvider theme={theme}>
      <LayoutProvider layout={DesignLayoutType.aloha}>
        <FontPackProvider eventDesign={data.eventByName.eventDesign}>
          <SmartAppBannerProvider>
            <UnlockDialogProvider>
              <ColorPaletteProvider eventDesign={data.eventByName.eventDesign}>
                <EventTopBar
                  eventHandle={eventHandle}
                  onMenuOpen={handleMenuOpen}
                />
                <EventMenu
                  eventHandle={eventHandle}
                  title={data.eventByName.info.eventDisplayName}
                  eventProps={{
                    eventId: data.eventByName.id,
                    layoutType: DesignLayoutType.aloha,
                    dateInMilliseconds: data.eventByName.info.dateV0918?.milliseconds || 0,
                    pages: data.eventByName.pages,
                  }}
                  hideMenuButton={true}
                  isOpen={isDrawerOpen}
                  onOpen={handleMenuOpen}
                  onClose={handleMenuClose}
                />
              </ColorPaletteProvider>
            </UnlockDialogProvider>
          </SmartAppBannerProvider>
        </FontPackProvider>
      </LayoutProvider>
    </JoyKitThemeProvider>
  );
};
